import type { i18n as I18n } from 'i18next';

/**
 * The language the page text is in. A detected language the portal has no translation for
 * (`de-DE`) shows the fallback, so `resolvedLanguage` names it rather than `language`.
 */
function shownLanguage(instance: I18n): string | undefined {
    return instance.resolvedLanguage ?? instance.language;
}

function applyLanguage(language: string | undefined): void {
    if (language) document.documentElement.lang = language;
}

/**
 * Keeps `<html lang>` on the language the portal is shown in, so screen readers pronounce
 * the text in it and the browser hyphenates and offers translation correctly. Call it before
 * `init` to catch the detected language; on a running instance it applies the current one.
 */
export function syncDocumentLanguage(instance: I18n): void {
    instance.on('languageChanged', () => applyLanguage(shownLanguage(instance)));
    if (instance.isInitialized) applyLanguage(shownLanguage(instance));
}
